import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'ftcfPoints', pure: true, standalone: true })
export class FtcfPointsPipe implements PipeTransform {
  transform(points: { x: number; y: number }[]): string {
    return points.map(p => `${p.x},${p.y}`).join(' ');
  }
}
